// import React from 'react'
import axios from 'axios'
import { setAlert } from './alert'
import { Redirect } from 'react-router-dom'
// import { getTournList } from './tournament'

import {
	REGISTER_SUCCESS,
	REGISTER_FAIL,
	USER_LOADED,
	AUTH_ERROR,
	LOGIN_SUCCESS,
	LOGIN_FAIL,
	LOGOUT,
	CLEAR_PROFILE,
	EXIT_EDIT_TOURNAMENT,
	USER_TOURN_ALERTS_IS_REGISTERED,
} from './types'
import setAuthToken from '../utils/setAuthToken'

// Load User
export const loadUser = () => async dispatch => {
	if (localStorage.token) {
		setAuthToken(localStorage.token)
	}

	try {
		const res = await axios.get('/api/auth')
		// console.log('actions/auth.js -------------------------------------')
		// console.log('loadUser -> res.data -> actions/auth.js = ', res.data)

		dispatch({
			type: USER_LOADED,
			payload: res.data,
		})

		if (res.data.tournAlerts) {
			// console.log('res.data.tournAlerts = ', res.data.tournAlerts)

			if (res.data.tournAlerts.registered) {
				dispatch({
					type: USER_TOURN_ALERTS_IS_REGISTERED,
				})
			}
		}

		// dispatch(getTournList(res._id))
	} catch (err) {
		dispatch({
			type: AUTH_ERROR,
		})
	}
}

// Register User
export const register = ({ name, email, password, role, history }) => async dispatch => {
	const config = {
		headers: {
			'Content-Type': 'application/json',
		},
	}

	const body = JSON.stringify({ name, email, password, role })

	try {
		const res = await axios.post('/api/users', body, config)

		dispatch({
			type: REGISTER_SUCCESS,
			payload: res.data,
		})

		dispatch(loadUser())
	} catch (err) {
		const errors = err.response.data.errors

		if (errors) {
			errors.forEach(error => dispatch(setAlert(error.msg, 'danger')))
		}

		dispatch({
			type: REGISTER_FAIL,
		})
	}
}

// Login User
export const login = (email, password) => async dispatch => {
	const config = {
		headers: {
			'Content-Type': 'application/json',
		},
	}

	const body = JSON.stringify({ email, password })

	try {
		const res = await axios.post('/api/auth', body, config)
		// console.log('login post -> res.data = ', res.data)

		dispatch({
			type: LOGIN_SUCCESS,
			payload: res.data,
		})

		dispatch(loadUser())
	} catch (err) {
		const errors = err.response.data.errors

		if (errors) {
			errors.forEach(error => dispatch(setAlert(error.msg, 'danger')))
		}

		dispatch({
			type: LOGIN_FAIL,
		})
	}
}

// Logout / Clear Profile
export const logout = () => dispatch => {
	dispatch({ type: CLEAR_PROFILE })
	dispatch({ type: EXIT_EDIT_TOURNAMENT })
	dispatch({ type: LOGOUT })
}
